import React from "react";
import Counter from "_c/MetaCounter";
import * as S from "./styled";
import ShareIcon from "_c/icon/Share";
import CommentIcon from "_c/icon/Comment";
import StarIcon from "_c/icon/Star";
import PT from "prop-types";
import { SITE_URL } from "@/misc/constants";

const Meta = (props) => {
  return (
    <S.CounterWrap>
      <Counter count={props.comments}>
        <CommentIcon color="var(--color-primary)" />
      </Counter>
      <Counter
        title={props.t(`common:${props.isFavorite ? "remove_like" : "like"}`)}
        onClick={props.onStarClick}
        count={props.likes}
      >
        <StarIcon filled={props.isFavorite} color="var(--color-primary)" />
      </Counter>
      <Counter
        title={props.t("common:photo_share")}
        onClick={() =>
          props.openShareModal(`${SITE_URL}/portfolio/${props.id}`)
        }
      >
        <ShareIcon color="var(--color-primary)" />
      </Counter>
    </S.CounterWrap>
  );
};
Meta.propTypes = {
  likes: PT.number.isRequired,
  comments: PT.number.isRequired,
  id: PT.string.isRequired,
  isFavorite: PT.bool.isRequired,

  t: PT.func.isRequired,
  onStarClick: PT.func.isRequired,
  toggleLike: PT.func.isRequired,
};
export default Meta;
